import { Alert, Col, Form, message, Row, Tag } from "antd";
import { MazakaButton } from "apps/Common/MazakaButton";
import { MazakaForm } from "apps/Common/MazakaForm";
import useMazakaForm from "hooks/useMazakaForm";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { editContract } from "../../Services";
import MazakaTextEditor from "apps/Common/MazakaTextEditor";
import { useGetContractDetails } from "../../ServerSideStates";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";

const GeneralCondition = () => {
  const [form] = Form.useForm();
  const [searchParams, setSearchParams] = useSearchParams();
  const { formActions, mazakaForm } = useMazakaForm(form);
  const contractId = searchParams.get("contractId");
  const contractDetails = useGetContractDetails(contractId || "");
  let contractData = contractDetails?.data?.data;

  useEffect(() => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set("key", "generalConditions");
      return newParams;
    });
  }, []);

  useEffect(() => {
    if (contractData?.content) {
      form.setFieldValue("content", JSON.parse(contractData["content"]));
    }
  }, [contractDetails.data]);

  const handleOnFinish = async () => {
    mazakaForm.setLoading();
    let formValues = form.getFieldsValue();
    formValues["content"] = JSON.stringify(formValues["content"]) || "";
    try {
      const response: any = await editContract({ ...contractData, ...formValues });
      setSearchParams((prev) => {
        const newParams = new URLSearchParams(prev);
        newParams.set("contractId", response?.data?.id);
        return newParams;
      });
      mazakaForm.setSuccess(2000, () => "İşlem Başarılı");
    } catch (error: any) {
      mazakaForm.setFailed(2000, error?.message);
    }
  };

  const labels = [
    { key: "#advisorName#", label: "Danışman Adı" },
    { key: "#advisorTcNo#", label: "Danışman Tc No" },
    { key: "#tenantName#", label: "Kiracı Adı" },
    { key: "#tenantTcNo#", label: "Kiracı Tc No" },
    { key: "#ownerName#", label: "Mülk Sahibi" },
    { key: "#ownerTcNo#", label: "Mülk Sahibi Tc No" },
    { key: "#description#", label: "Açıklama" },
    { key: "#deedInfo#", label: "Tapu Bilgisi" },
    { key: "#realEstateType#", label: "Taşınmaz Cinsi" },
    { key: "#startDate#", label: "Başlangıç Tarihi" },
    { key: "#endDate#", label: "Bitiş Tarihi" },
    { key: "#monthlyRentalFee#", label: "Aylık Kira Bedeli" },
    { key: "#annualRentalFee#", label: "Yıllık Kira Bedeli" },
    { key: "#increaseRate#", label: "Artış Oranı" },
    { key: "#deposit#", label: "Depozito" },
    { key: "#downPayment#", label: "Peşinat" },
    { key: "#currency#", label: "Para birimi" },
    { key: "#paymentType#", label: "Ödeme Tipi" },
  ];
  
  const validateAndCopy = (key: string,label:string) => {
    const lowerKey = key?.replace(/#/g,"");

   
    if (
      contractData &&
      contractData[lowerKey] !== undefined &&
      contractData[lowerKey] !== null &&
      contractData[lowerKey] !== ""
    ) {
      navigator.clipboard.writeText(key);
      message.success(`${label} kopyalandı`);
    } else {
      openNotificationWithIcon("default","Bu alanı doldurmalısınız");
    }
  };


  useEffect(()=>{contractDetails.refetch()},[])

  return (
    <>
      <Col span={24} className="!mt-6">
        <MazakaForm submitButtonVisible={false} form={form} initialValues={{ contractTypeId: 2002 }} onFinish={handleOnFinish}>
          <Row gutter={[10, 20]} className="">
            <Col xs={24}>
              <Alert closable className="!p-4 !text-xs" message="Aşağıdaki kutularda yer alan değerleri sözleşme içinde uygun yerlere koymak için kutunun üstüne tıklayıp, sözleşmede istediğiniz yere yapıştırabilirsiniz." />
            </Col>
            <Col xs={24} className="!flex flex-wrap gap-4">
              {labels.map(({ key, label }) => (
                <Tag className="!cursor-pointer" key={key} color="blue" onClick={() => validateAndCopy(key,label)}>
                  {label}
                </Tag>
              ))}
            </Col>
            <MazakaTextEditor xs={24} label="Genel Şartlar" placeholder="Genel Şartlar" name="content" form={form} />
            <Col span={24}>
              <MazakaButton className="!p-4 !bg-[#FFC502] !text-black" htmlType="submit" block processType={formActions.submitProcessType}>
                Kaydet
              </MazakaButton>
            </Col>
          </Row>
        </MazakaForm>
      </Col>
    </>
  );
};

export default GeneralCondition;
